export const SeoTaskCSS = {
  header: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  headerButton: {
    pt: 0,
    pb: 0,
    fontSize: {
      xs: '10px',
      sm: '14px',
      md: '14px',
      lg: '14px'
    },
    height: { sm: '60px', md: '40px', lg: '40px' },
    ml: 1,
    fontFamily: 'Inter !important',
    fontWeight: 500
  },
  breadCrumbLight: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)',
    cursor: 'pointer'
  },
  breadCrumbText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  headTitleTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-24)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-32)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  squareIconSx: {
    marginTop: '2.5px'
  },
  titleToShowText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-text-heading)'
  },
  titleToShowBox: {
    display: 'flex',
    gap: '0px',
    alignItems: 'center'
  },
  exportCsvBoxSx: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: 3
  },
  exportCsvBtnSx: {
    padding: '10px 16px 10px 16px',
    gap: '6px',
    borderRadius: '6px',
    borderColor: 'var(--color-text-muted-purple)'
  },
  exportCsvBtnTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  tableHeaderRowSecondTable: {
    '& .MuiTableCell-root': {
      borderTop: 'none',
      backgroundColor: 'rgba(247, 244, 252, 1)'
    }
  },
  scanUrlSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)',
    padding: '16px 16px 16px 0px',
    whiteSpace: 'normal', // Allows wrapping
    wordBreak: 'break-all', // Breaks long words or URLs
    overflowWrap: 'break-word', // Fallback for better wrapping
    minWidth: '250px'
  },
  rowIssueSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  createdAtSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-text-tertiary)'
  }
};
export const BegginnerCardCSS = {
  gridContainer: {
    marginTop: 2
  },
  gridBoxCss: {
    padding: '24px',
    gap: '0px',
    borderRadius: '12px',
    opacity: ' 0px',
    backgroundColor: 'var(--color-white)',
    boxShadow: '0px 1px 8px 0px rgba(52, 52, 83, 0.14)'
  },
  headBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  headTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-20)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-30)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  numBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '24px'
  },
  iconBoxCss: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  numTextCss: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-44)',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  perSx: {
    //styleName: Text lg/Semibold;
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'rgba(18, 183, 106, 1)'
  },
  descSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  tableHeadSx: {
    padding: '16px 0px 16px 0px'
  },
  tableCellPage: {
    paddingLeft: '0px !important'
  },
  tableCellTraffic: {
    paddingRight: '0px !important'
  },
  tHeadTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-muted-purple)'
  },
  tHeadAlignment: {
    textAlign: 'right'
  },
  tCellText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'rgba(41, 50, 65, 1)'
  },
  dashSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-36)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-44)',
    letterSpacing: '-0.02em',
    textAlign: 'left',
    color: 'var(--color-text-secondary)'
  },
  loaderBox: {
    display: 'flex',
    justifyContent: 'center'
  },
  progressCSS: {
    mt: 1,
    bgcolor: 'var(--color-success-bg)',
    borderRadius: 5,
    height: '16px',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'var(--color-secondary)'
    },
    '& .MuiLinearProgress-barBuffer': {
      backgroundColor: 'var(--color-success-bg)'
    }
  },
  progressLabel: {
    fontSize: 'var(--font-size-14)',
    textAlign: 'center',
    fontWeight: '500 !important',
    color: 'var(--color-primary)',
    fontFamily: 'Inter',
    lineHeight: 'var(--line-height-20)'
  }
};
export const taskListCSS = {
  header: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-18)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-28)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  tabCSS: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 600,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    '& .MuiTab-root': {
      textTransform: 'none',
      marginRight: 4
    },
    '& .MuiTab-root:last-of-type': {
      marginRight: 0
    }
  },
  chipCritical: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-error-darkest)',
    ml: 1,
    background: '#FECDCA'
  },
  chipRecommended: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: '#DC6803',
    ml: 1,
    background: '#FDDCAB'
  },
  chipOptional: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: '#741395',
    ml: 1,
    background: 'var(--color-bg-purple-light2)'
  },
  chipAll: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-white)',
    ml: 1,
    background: 'var(--color-primary)'
  },
  tableContainer: {
    border: 'none',
    boxShadow: 'none',
    borderRadius: '2px'
  },
  tableHeaderRow: {
    '& .MuiTableCell-root': {
      borderTop: 'none',
      borderBottom: 'none',
      backgroundColor: 'rgba(247, 244, 252, 1)'
    }
  },
  tableHeadText: {
    width: 'max-content',
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-purple)'
  },
  tableSortLabel: {
    '.MuiTableSortLabel-icon': {
      opacity: 1,
      color: 'var(--color-text-tertiary)'
    }
  },
  tableCellText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-near-black)'
  },
  addOutlinedIcon: {
    color: 'var(--color-primary)',
    width: '20px',
    height: '20px',
    cursor: 'pointer'
  },
  tabSelectedLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 700,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-primary)'
  },
  tabNotSelectedLabelSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 400,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left'
  },
  squareIcon: {
    marginTop: '2.5px'
    // marginLeft: '1rem'
  },
  tabLineBoxTitle: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-16)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-24)',
    textAlign: 'left',
    color: 'rgba(31, 37, 42, 1)'
  },
  watchTutorialText: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-mid)'
  },
  rowTitleTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-purple-strong)'
  },
  rowCountTextSx: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-15)',
    fontWeight: 500,
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    color: 'var(--color-text-muted)'
  },
  tableRowSx: {
    // border: '1px solid red !important',
    // borderRadius: '6px !important'
    '&:hover': {
      backgroundColor: 'rgba(246, 243, 255, 1)'
    },
    cursor: 'pointer'
  },
  chipCompleted: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-white)',
    backgroundColor: 'var(--color-primary)',
    opacity: 0.8,
    marginLeft: '8px'
  },
  chipAiVisibility: {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 'var(--line-height-18)',
    textAlign: 'left',
    color: 'var(--color-white)',
    ml: 1,
    background: 'linear-gradient(150deg, var(--color-primary) 9.79%, var(--color-secondary) 90.56%)'
  },
  reviewDescSx: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 'var(--font-size-14)',
    lineHeight: 'var(--line-height-20)',
    color: 'var(--color-text-secondary)'
  }
};

export const SeoTaskChipSx = {
  seoText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-primary)'
  },
  aioText: {
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: 'var(--line-height-14)',
    color: 'var(--color-white)'
  },
  aioBox: {
    width: '40px',
    height: '20px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(150deg, var(--color-primary) 9.79%, var(--color-secondary) 90.56%)'
  },
  seoBox: {
    width: '40px',
    height: '20px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'var(--color-bg-purple-light2)'
  },
  subBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
};
